<div class="container-fluid" style="padding-left: 0; padding-right: 0">
  <p-table [totalRecords]="recentObservations?.length" #ttt [value]="recentObservations" styleClass="p-datatable-striped p-datatable-responsive-eca"
           [scrollable]="!isOnMobile &&    recentObservations?.length > 5" scrollHeight="500px" dataKey="observationId" [responsive]="true" [columns]="columns"
           [globalFilterFields]="['operativeName','companyName', 'observedOn.dateTime', 'notesAsHtml','summaryInfo','observedBy','followUpOn.dateTime','observationType']">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 12.5%;" pSortableColumn="operativeName">
          Owner
          <p-sortIcon field="operativeName"></p-sortIcon>
        </th>
        <th style="width: 12.5%;" pSortableColumn="observationType">
          Type
          <p-sortIcon field="observationType"></p-sortIcon>
        </th>
        <th style="width: 11.5%;" pSortableColumn="observedBy">
          Observer
          <p-sortIcon field="observedBy"></p-sortIcon>
        </th>
        <th style="width: 11.5%;" pSortableColumn="observedOn.dateTime">
          Date Observed
          <p-sortIcon field="observedOn.dateTime"></p-sortIcon>
        </th>
        <th style="width: 11.5%;" pSortableColumn="followUpOn.dateTime">
          Followup
          <p-sortIcon field="followUpOn.dateTime"></p-sortIcon>
        </th>
        <th style="width: 12.5%;" pSortableColumn="summaryInfo">
          Information
          <p-sortIcon field="summaryInfo"></p-sortIcon>
        </th>
        <th style="width: 15.5%;" pSortableColumn="notesAsHtml">
          Notes
          <p-sortIcon field="notesAsHtml"></p-sortIcon>
        </th>
        <th style="font-weight: bold; width: 12.5%;"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-recentObservation let-columns="columns">
      <tr>
        <td *ngFor="let col of columns">
          <span class="p-column-title">{{col.header}}: </span>
          <label *ngIf="col.type=== 'owner'">
            <span *ngIf=" recentObservation.observationType !== ObservationType.CompanyDocument || recentObservation.observationType !== ObservationType.Company">
              <a [routerLink]="['/operative',recentObservation?.operativeId]"> {{recentObservation[col.field]}}</a>
            </span>
            <span *ngIf="recentObservation.observationType === ObservationType.CompanyDocument || recentObservation.observationType === ObservationType.Company">
              {{recentObservation.companyName}}
            </span>
          </label>
          <label>
            <span *ngIf="col.type=== 'text'">
              {{recentObservation[col.field]}}
            </span>
            <span *ngIf="col.type === 'date'">
              {{recentObservation[col.field]?.dateTime | date:'dd/MM/yyyy'}}
            </span>
            <span *ngIf="col.type === 'type'">
              {{ObservationTypeString[ recentObservation[col.field]]}}
            </span>
          </label>
         <label *ngIf="col.type === 'html'" [innerHTML]="recentObservation[col.field] | ellipsis:70"></label>
        </td>
        <td>
          <div class="text-center">
            <app-eca-row-menu (viewBtnClicked)="viewObservation(recentObservation)"
                              [rowMenuVisible]="allowDelete"
                              [rowMenuItems]="rowMenuItems"
                              [contextItem]="recentObservation?.observationId">
            </app-eca-row-menu>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
